import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getRemittanceParameters } from '@shared/services/api/remittancesService';

export const fetchRemittanceParameters = createAsyncThunk(
  'remittanceParameters/fetch',
  async (_: void, { rejectWithValue }) => {
    try {
      const response = await getRemittanceParameters();
      if (response?.errors?.length > 0) {
        const isPartial = response.errors[0].code === 'REM/parameters-partial';
        if (isPartial && response.data) {
          console.warn('[remittanceParameters] upstream shape partial, using data anyway');
          return response.data;
        }
        return rejectWithValue(response.errors[0].message);
      }
      return response?.data ?? response;
    } catch (error) {
      return rejectWithValue('No se pudieron cargar los parámetros de remesas.');
    }
  }
);

const remittanceParametersSlice = createSlice({
  name: 'remittanceParameters',
  initialState: {
    data: null,
    loading: false,
    error: null,
    selectedRemittanceCompany: null,
  },
  reducers: {
    setSelectedRemittanceCompany: (state, action) => {
      state.selectedRemittanceCompany = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRemittanceParameters.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRemittanceParameters.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchRemittanceParameters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { setSelectedRemittanceCompany } = remittanceParametersSlice.actions;

export default remittanceParametersSlice.reducer;
